import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import ServerError from "../pages/ServerError";
import Home from "../pages/home/page";
import HackersPage from "../pages/hackers/page";
import HackerDetailPage from "../pages/hacker-detail/page";
import ProjectsPage from "../pages/projects-listing/page";
import ProjectDetailPage from "../pages/project-detail/page";
import ContactPage from "../pages/contact/page";
import HackingNewsPage from "../pages/hacking-news/page";
import NewsDetailPage from "../pages/news-detail/page";
import ServiceSelectionPage from "../pages/post-project/page";
import PostProjectCategoryPage from "../pages/post-project/category/page";
import DashboardPage from "../pages/dashboard/page";
import AdminLayout from "../pages/admin/layout";
import AdminDashboard from "../pages/admin/page";
import AdminUsersPage from "../pages/admin/users/page";
import AdminHackersPage from "../pages/admin/hackers/page";
import AdminHackerDetailPage from "../pages/admin/hackers/detail/page";
import AdminWalletsPage from "../pages/admin/wallets/page";
import AdminProjectsPage from "../pages/admin/projects/page";
import AdminTransactionsPage from "../pages/admin/transactions/page";
import ResetPasswordPage from "../pages/reset-password/page";
import AdminLoginPage from "../pages/admin/login/page";
import CryptoPaymentPage from "../pages/payment/crypto/page";
import PrivacyPage from "../pages/privacy/page";
import TermsPage from "../pages/terms/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hackers",
    element: <HackersPage />,
  },
  {
    path: "/hacker/:id",
    element: <HackerDetailPage />,
  },
  {
    path: "/projects-listing",
    element: <ProjectsPage />,
  },
  {
    path: "/project/:id",
    element: <ProjectDetailPage />,
  },
  {
    path: "/post-project",
    element: <ServiceSelectionPage />,
  },
  {
    path: "/post-project/:category",
    element: <PostProjectCategoryPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/hacking-news",
    element: <HackingNewsPage />,
  },
  {
    path: "/hacking-news/:slug",
    element: <NewsDetailPage />,
  },
  {
    path: "/dashboard",
    element: <DashboardPage />,
  },
  {
    path: "/reset-password",
    element: <ResetPasswordPage />,
  },
  {
    path: "/payment/crypto",
    element: <CryptoPaymentPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPage />,
  },
  {
    path: "/terms",
    element: <TermsPage />,
  },
  // Error Pages
  {
    path: "/500",
    element: <ServerError />,
  },
  // Admin Routes — nested under /admin, with /admin/login/22 redirect
  {
    path: "/admin",
    element: <AdminLayout />,
    children: [
      { index: true, element: <AdminDashboard /> },
      { path: "users", element: <AdminUsersPage /> },
      { path: "hackers", element: <AdminHackersPage /> },
      { path: "hackers/:id", element: <AdminHackerDetailPage /> },
      { path: "wallets", element: <AdminWalletsPage /> },
      { path: "transactions", element: <AdminTransactionsPage /> },
      { path: "projects", element: <AdminProjectsPage /> },
    ],
  },
  {
    path: "/admin/login/22",
    element: <AdminLoginPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;